import axios from 'axios';
import apiUrl from '../constants';

export function mpsDetails(input, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'fetchShipmentsAgainstMPS',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}



// WEBPACK FOOTER //
// ./src/services/mpsDetails.js